import React from 'react';

import {isContentTypeOfExtensionsMap} from '@app/src/common/helpers/getItemContentType';
import {
  DOCUMENT_EXTENSIONS_MAP,
  IMAGE_EXTENSIONS_MAP, POWERPOINT_EXTENSIONS_MAP,
  VIDEO_EXTENSIONS_MAP
} from '@app/src/components/file-storage/constants/galleryConstants';

import ImageIcon from '@app/src/assets/icons/img.svg';
import VideoIcon from '@app/src/assets/icons/Video.svg';
import PdfIcon from '@app/src/assets/icons/pdf.svg';
import PptIcon from '@app/src/assets/icons/ppt.svg';


export const getLoadingPreviewIcon = (contentType: string) => {
  if (isContentTypeOfExtensionsMap(contentType, DOCUMENT_EXTENSIONS_MAP)) {
    return <PdfIcon />;
  } else if (isContentTypeOfExtensionsMap(contentType, IMAGE_EXTENSIONS_MAP)) {
    return <ImageIcon />;
  } else if (isContentTypeOfExtensionsMap(contentType, VIDEO_EXTENSIONS_MAP)) {
    return <VideoIcon />;
  } else if (isContentTypeOfExtensionsMap(contentType, POWERPOINT_EXTENSIONS_MAP)) {
    return <PptIcon />;
  }
};

